import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./RegisterCorporateEmployee.css";

const RegisterCorporateEmployee = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { empId, companyCode, name } = state || {}; 

  const [formData, setFormData] = useState({
    Age: "",
    Gender: "",
    Location: "",
    Mobile: "",
    Problem: "",
    Department: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch(
        "https://backend-xhl4.onrender.com/CorporateRoute/registerCorporateEmployee",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
            empId,
            companyCode,
            Name: name, // ✅ send name directly
            userType: "corporate",
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setMessage(
          "🎉 Registered successfully. You can now take the Psychometric test."
        );
        setTimeout(() => navigate("/StartScreeningTest", 5000));
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (err) {
      setMessage("Error registering employee. Please try again.");
    }
  };

  return (
    <div className="register-employee-main">
      <div className="register-employee-container">
        <h2>Corporate Employee Registration</h2>

        <form className="employee-form" onSubmit={handleRegister}>
          <p>
            <strong>Company Code:</strong> {companyCode}
          </p>
          <p>
            <strong>Employee ID:</strong> {empId}
          </p>
          <p>
            <strong>Name:</strong> {name}
          </p>

          <input
            name="Age"
            placeholder="Age"
            value={formData.Age}
            onChange={handleChange}
            required
          />

          <select
            name="Gender"
            value={formData.Gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

          <input
            name="Location"
            placeholder="City / Location"
            value={formData.Location}
            onChange={handleChange}
            required
          />
          <input
            name="Mobile"
            placeholder="Mobile Number"
            value={formData.Mobile}
            onChange={handleChange}
            required
          />
          <select
            name="Department"
            value={formData.Department}
            onChange={handleChange}
            required
          >
            <option value="">Select Department</option>
            <option value="Human Resources">Human Resources (HR)</option>
            <option value="Finance">Finance</option>
            <option value="Marketing">Marketing</option>
            <option value="Sales">Sales</option>
            <option value="Engineering">Engineering</option>
            <option value="Information Technology">
              Information Technology (IT)
            </option>
            <option value="Operations">Operations</option>
            <option value="Customer Support">Customer Support</option>
            <option value="Research and Development">
              Research and Development (R&D)
            </option>
            <option value="Administration">Administration</option>
            <option value="Other">Other</option>
          </select>

          <select
            name="Problem"
            value={formData.Problem}
            onChange={handleChange}
            required
          >
            <option value="">Select Problem</option>
            <option value="Stress">Stress</option>
            <option value="Anxiety">Anxiety</option>
            <option value="Depression">Depression</option>
            <option value="Work Burnout">Work Burnout</option>
            <option value="Sleep Issues">Sleep Issues</option>
            <option value="Relationship Issues">Relationship Issues</option>
            <option value="Low Self-esteem">Low Self-esteem</option>
            <option value="Anger Management">Anger Management</option>
            <option value="Work Pressure">Work Pressure</option>
            <option value="Concentration Issues">Concentration Issues</option>
            <option value="Other">Other</option>
          </select>

          <button type="submit">Register</button>
        </form>

        {message && (
          <p className={message.includes("successfully") ? "success" : "error"}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default RegisterCorporateEmployee;
